import { subscribe } from './event-logger';
import { GOOGLE_EVENT_TYPES } from './event-types';


const gtagTracker = {
    track(eventType) {
        gtag('event', 'conversion', {
            'send_to': eventType
        });
    }
};

subscribe((eventType) => {
    if (GOOGLE_EVENT_TYPES.hasOwnProperty(eventType)) {
        gtagTracker.track(GOOGLE_EVENT_TYPES[eventType]);
    }
});

export {
    gtagTracker
}
